<template>
  <div>
    <payment-remark-add-new
        :is-add-new-payment-remark-sidebar-active.sync="isAddNewPaymentRemarkSidebarActive"
        :id="id"
        :data="paymentremarkData"
        @refetch-data="refetchData"
        v-if="ability.can('create','payment-remarks')"
    >
    </payment-remark-add-new>
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap">新增支付備註</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refPaymentRemarkListTable"
        class="position-relative"
        :items="fetchPaymentRemarks"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(remark)="data">
        <span style="white-space: pre-wrap;">{{data.item.remark}}</span>
    </template>
    <template #cell(action)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','payment-remarks')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">修改</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="ability.can('delete','payment-remarks')" @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">刪除</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalPaymentRemarks"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import paymentremarkStoreModule from "../paymentremarkStoreModule";
import usePaymentRemarksList from "./usePaymentRemarksList";
import PaymentRemarkAddNew from "./PaymentRemarkListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    PaymentRemarkAddNew,
  },
  methods:{
    confirmDelete(id){
        this.$swal({
        title: '確定刪除?',
        text: '此操作無法撤銷',
        showCancelButton: true,
        confirmButtonText: '刪除',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      .then(result => {
        if (result.value) {
          this.$store.dispatch("setting-paymentremark/deletePaymentRemark", {'id': id})
          .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })
              this.refetchData()
          }).catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })

          })
        }
      })
      },
      handleCreate(){
          this.id = 0
          this.resetPaymentRemarkData()
          this.isAddNewPaymentRemarkSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.paymentremarkData = {...item}
        this.isAddNewPaymentRemarkSidebarActive = true
        
      }, resetPaymentRemarkData(){
        this.paymentremarkData = {
            id: 0,
            name: '',
            remark: ''
        }
      }
  },
  data(){
    return {
        id:0,
        paymentremarkData:{},
    }  
  },
  setup() {
    const SETTING_PAYMENT_REMARK_STORE_MODULE_NAME = "setting-paymentremark";

    if (!store.hasModule(SETTING_PAYMENT_REMARK_STORE_MODULE_NAME))
      store.registerModule(
        SETTING_PAYMENT_REMARK_STORE_MODULE_NAME,
        paymentremarkStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(SETTING_PAYMENT_REMARK_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_PAYMENT_REMARK_STORE_MODULE_NAME);
    });

    const isAddNewPaymentRemarkSidebarActive = ref(false);

    const {
      fetchPaymentRemarks,
      tableColumns,
      perPage,
      currentPage,
      totalPaymentRemarks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPaymentRemarkListTable,
      refetchData,
      ability,
    } = usePaymentRemarksList();

    return {
      //Sidebar
      isAddNewPaymentRemarkSidebarActive,

      fetchPaymentRemarks,
      tableColumns,
      perPage,
      currentPage,
      totalPaymentRemarks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPaymentRemarkListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>../paymentremarkStoreModule./usePaymentRemarksList